<template>
  <div class="container mx-auto relative p-6">
    <div class="h-120 rounded-lg flex flex-col justify-center items-center p-12 text-center bg-grey-lighter border-dashed border-4">
      <i class="fab fa-instagram text-5xl mb-6"></i>
      <p>The Instagram page configured on your campaign will be displayed here.</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
